import LenderProgramRequestDetail from './LenderProgramRequestDetail';

export default LenderProgramRequestDetail;
